import { defineStore } from 'pinia'
import { ref } from 'vue'

const BRADLEY_PANEL_WIDTH_MIN = 40
const BRADLEY_PANEL_WIDTH_MAX = 60
const BRADLEY_PANEL_WIDTH_DEFAULT = 50

export const useUIStore = defineStore('ui', () => {
  const isLoading = ref(false)
  const loadingMessage = ref('')
  const sidebarCollapsed = ref(false)
  const bradleyPanelOpen = ref(false)
  const bradleyPanelWidthPercent = ref(BRADLEY_PANEL_WIDTH_DEFAULT)
  const bradleyPanelExpanded = ref(false)
  const bradleyPanelStartFreshSession = ref(false)
  const bradleyFloatingWidgetVisible = ref(false)
  const fullscreenMode = ref(false)

  function setFullscreenMode(value) {
    fullscreenMode.value = value
  }

  function toggleFullscreenMode() {
    fullscreenMode.value = !fullscreenMode.value
  }

  function setSidebarCollapsed(value) {
    sidebarCollapsed.value = value
  }

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function openSidebar() {
    sidebarCollapsed.value = false
  }

  function closeSidebar() {
    sidebarCollapsed.value = true
  }

  function showLoading(message = '') {
    isLoading.value = true
    loadingMessage.value = message
  }

  function hideLoading() {
    isLoading.value = false
    loadingMessage.value = ''
  }

  function openBradleyPanel(options = {}) {
    const startNewChat = Boolean(options.startNewChat)
    bradleyPanelOpen.value = true
    if (startNewChat) {
      bradleyPanelStartFreshSession.value = true
      bradleyFloatingWidgetVisible.value = false
      setBradleyPanelExpanded(false)
    }
    else {
      bradleyFloatingWidgetVisible.value = false
    }
  }

  function consumeBradleyPanelStartFreshSession() {
    bradleyPanelStartFreshSession.value = false
  }

  function closeBradleyPanel() {
    bradleyPanelOpen.value = false
    bradleyFloatingWidgetVisible.value = false
  }

  function minimizeBradleyPanel() {
    bradleyPanelOpen.value = false
    bradleyFloatingWidgetVisible.value = true
  }

  function toggleBradleyPanel() {
    bradleyPanelOpen.value = !bradleyPanelOpen.value
  }

  function setBradleyPanelWidth(percent) {
    const value = Number(percent)
    if (Number.isFinite(value)) {
      bradleyPanelWidthPercent.value = Math.min(
        BRADLEY_PANEL_WIDTH_MAX,
        Math.max(BRADLEY_PANEL_WIDTH_MIN, value),
      )
    }
  }

  function setBradleyPanelExpanded(expanded) {
    bradleyPanelExpanded.value = Boolean(expanded)
  }

  function toggleBradleyPanelExpanded() {
    bradleyPanelExpanded.value = !bradleyPanelExpanded.value
  }

  return {
    isLoading,
    loadingMessage,
    showLoading,
    hideLoading,
    sidebarCollapsed,
    setSidebarCollapsed,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    bradleyPanelOpen,
    bradleyPanelWidthPercent,
    bradleyPanelExpanded,
    bradleyPanelStartFreshSession,
    bradleyFloatingWidgetVisible,
    openBradleyPanel,
    consumeBradleyPanelStartFreshSession,
    closeBradleyPanel,
    minimizeBradleyPanel,
    toggleBradleyPanel,
    setBradleyPanelWidth,
    setBradleyPanelExpanded,
    toggleBradleyPanelExpanded,
    fullscreenMode,
    setFullscreenMode,
    toggleFullscreenMode,
    BRADLEY_PANEL_WIDTH_MIN,
    BRADLEY_PANEL_WIDTH_MAX,
    BRADLEY_PANEL_WIDTH_DEFAULT,
  }
}, {
  persist: {
    paths: ['sidebarCollapsed'],
  },
})
